module.exports = __webpack_public_path__ + "img/5_icn_bag.a7a39820.png";